import { v4 as uuidv4 } from 'uuid';
import { NIL as NIL_UUID } from 'uuid';
abstract class GUID {
  static readonly validGUIDRegex: RegExp =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$|^[0-9a-f]{32}$/i;
  static readonly emptyGUIDRegex: RegExp = /^0{8}-0{4}-0{4}-0{4}-0{12}$|^0{32}$/i;
  static readonly removeDashesRegex: RegExp = /\-/g;

  static create(): string {
    return uuidv4();
  }

  static empty(): string {
    return NIL_UUID;
  }

  static isValid(guid?: string | null): guid is string {
    return this.validGUIDRegex.test(guid ?? '');
  }

  static validateAll(...guids: (string | null | undefined)[]): boolean {
    return guids.every((guid) => this.isValid(guid));
  }

  static isEmpty(guid?: string | null): boolean {
    return this.emptyGUIDRegex.test(guid ?? '');
  }

  static isNullOrEmpty(guid?: string): boolean {
    return guid === null || guid === undefined || this.emptyGUIDRegex.test(guid);
  }

  static hasValue(guid?: string): boolean {
    return !this.isNullOrEmpty(guid) && this.isValid(guid);
  }

  static truncate(guid?: string | null): string {
    return guid?.replace(this.removeDashesRegex, '') ?? '';
  }

  static equals(guid1?: string, guid2?: string): boolean {
    if ((guid1 === null || guid1 === undefined) && (guid2 === null || guid2 === undefined)) {
      return true;
    }

    if (!this.validateAll(guid1, guid2)) {
      return false;
    }

    const trunc1 = this.truncate(guid1).toLowerCase();
    const trunc2 = this.truncate(guid2).toLowerCase();

    return trunc1 === trunc2;
  }
}

export default GUID;
